<template>
  <div v-if="data" ref="echars" class="echars-class">
  </div>
</template>

<script>
export default {
  name: "workExp",
  data: () => ({
    chats: undefined,
    data: undefined
  }),
  methods: {
    init(data) {
      this.data = data

      let _data = []
      this.data.forEach(item => {
        _data.push({
          name: item.workExp,
          value: item.percent,
          label: item.aveSalary
        })
      })

      let option = {
        // title: {
        //   text: '工作年限薪酬分布',
        //   left: 'left'
        // },
        grid: {
          // right: '0',
          containLabel: true,
        },
        tooltip: {
          trigger: 'item',
          formatter(params) {
            let {label, name, value} = params.data

            return `${name}：${value}<br/>平均月薪：￥${label}`
          }
        },
        legend: {
          orient: 'vertical',
          left: 'right',
          top: 'bottom',
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: _data,
          }
        ]
      };

      this.$nextTick(() => {
        this.chats = this.$echarts.init(this.$refs.echars, 'vintage', {renderer: 'canvas'})
        this.chats.setOption(option);
        this.chats.resize();
      })
    },
    resize() {
      this.$nextTick(() => {
        if (this.chats) {
          this.chats.resize();
        }
      })
    }
  }
}
</script>

<style scoped>
.echars-class {
  width: 100%;
  height: 100%;
}
</style>
